
export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Choose Your Focus',
      description: 'Select from confidence, calm, purpose, healing, or create your own intention for the day.',
      icon: 'ri-focus-3-line',
      gradient: 'from-[#E8F4FF] to-[#FFE8DC]'
    },
    {
      number: '02',
      title: 'Receive Daily Affirmations',
      description: 'Get identity-based "I am" statements designed to reshape your self-talk and mindset.',
      icon: 'ri-message-3-line',
      gradient: 'from-[#FFE8DC] to-[#FFE4E8]'
    },
    {
      number: '03',
      title: 'Reflect and Journal',
      description: 'Spend just a few minutes with guided prompts to gain clarity and process your thoughts.',
      icon: 'ri-edit-box-line',
      gradient: 'from-[#FFE4E8] to-[#F0E8FF]'
    },
    {
      number: '04',
      title: 'Track Your Growth',
      description: 'Revisit past reflections and see how your mindset and perspective evolve over time.',
      icon: 'ri-line-chart-line',
      gradient: 'from-[#F0E8FF] to-[#E8F4FF]'
    }
  ];

  return (
    <section className="bg-[#F7F3EF] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <h2 className="text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-16">
          How It Works
        </h2>

        {/* Desktop: Grid Layout */}
        <div className="hidden lg:grid lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-[#FFFCF8] rounded-3xl p-8 shadow-sm hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${step.gradient} flex items-center justify-center mb-6 mx-auto`}>
                <i className={`${step.icon} text-3xl text-[#2C2C2C]`}></i>
              </div>
              <div className="text-xs uppercase tracking-widest text-[#8B8B8B] mb-3 text-center">
                Step {step.number}
              </div>
              <h3 className="text-xl font-semibold text-[#2C2C2C] mb-3 text-center">
                {step.title}
              </h3>
              <p className="text-sm text-[#5A5A5A] leading-relaxed text-center">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Mobile: Horizontal Scroll */}
        <div className="lg:hidden overflow-x-auto pb-4 -mx-6 px-6">
          <div className="flex gap-6" style={{ width: 'max-content' }}>
            {steps.map((step, index) => (
              <div
                key={index}
                className="bg-[#FFFCF8] rounded-3xl p-8 shadow-sm w-72 flex-shrink-0"
              >
                <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${step.gradient} flex items-center justify-center mb-6 mx-auto`}>
                  <i className={`${step.icon} text-3xl text-[#2C2C2C]`}></i>
                </div>
                <div className="text-xs uppercase tracking-widest text-[#8B8B8B] mb-3 text-center">
                  Step {step.number}
                </div>
                <h3 className="text-xl font-semibold text-[#2C2C2C] mb-3 text-center">
                  {step.title}
                </h3>
                <p className="text-sm text-[#5A5A5A] leading-relaxed text-center">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
